// Consent copy names the band's shelves, not the MUST_NOT_HAVE rows that enforce them.
import type { RestrictionPlacement } from "./studioTypes";

/** Shelves (or bays) as runs: "1–2, 5", each run worded by `range` where it is given. */
export const shelfSpanLabel = (
  shelves: readonly number[],
  range: (from: number, to: number) => string = (from, to) => `${from}–${to}`,
): string => {
  const sorted = [...new Set(shelves)].sort((a, b) => a - b);
  if (sorted.length === 0) return "";
  const parts: string[] = [];
  let start = sorted[0];
  let previous = sorted[0];
  const flush = () => parts.push(start === previous ? `${start}` : range(start, previous));
  for (const shelf of sorted.slice(1)) {
    if (shelf === previous + 1) {
      previous = shelf;
      continue;
    }
    flush();
    start = shelf;
    previous = shelf;
  }
  flush();
  return parts.join(", ");
};

export interface GateOwnershipLine {
  variant: string;
  shelves: string;
  shelfCount: number;
}

export const gateOwnershipLinesOf = (
  offers: readonly { bandVariant: string; placement: RestrictionPlacement }[],
  range?: (from: number, to: number) => string,
): GateOwnershipLine[] => {
  const byVariant = new Map<string, number[]>();
  for (const offer of offers) {
    byVariant.set(offer.bandVariant, [
      ...(byVariant.get(offer.bandVariant) ?? []),
      ...offer.placement.cells.map((cell) => cell.shelf),
    ]);
  }
  return [...byVariant.entries()].map(([variant, shelves]) => ({
    variant,
    shelves: shelfSpanLabel(shelves, range),
    shelfCount: new Set(shelves).size,
  }));
};
